import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useSocialMediaIcons } from "../Footer.hook";
import { fields } from "../constants";

export const AddEditSocialMediaIcons = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useSocialMediaIcons(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_social_media_name: decodeHTML(
        dataById ? dataById.payload.field_social_media_name : editData ? editData?.[0]?.field_social_media_name : ""
      ),
      field_social_media_name_ms: decodeHTML(
        dataById
          ? dataById.payload.field_social_media_name_ms
          : editData
            ? editData?.[0].field_social_media_name_ms
            : ""
      ),
      field_social_media_link: decodeHTML(
        dataById ? dataById.payload.field_social_media_link : editData ? editData?.[0].field_social_media_link : ""
      ),
      field_social_media_name_zh: decodeHTML(
        dataById
          ? dataById.payload.field_social_media_name_zh
          : editData
            ? editData?.[0]?.field_social_media_name_zh
            : ""
      ),
      status: decodeHTML(dataById ? dataById.payload.status : editData ? editData?.[0]?.status : ""),
      field_social_media_icon: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: dataById?.payload?.field_social_media_icon,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: editData?.[0]?.field_social_media_icon,
            },
          ]),
      publish: decodeHTML(dataById ? dataById.payload.publish : editData ? editData?.[0]?.publish : ""),
    },
    fields: fields.socialMediaIcons,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_social_media_icon"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          data[key] = ""; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Footer",
      subModule: `socialMediaIcons`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        // name: data?.field_social_media_name,
        ...data,
        // published: true,
      },
      status: status,
    };
    console.log(payload, "payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Social Media Icon`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update"}`
              ? `${eramanHost}/api/get-footer-section-icons-items-taxonomy-data-list/${editData?.[0]?.id || dataById?.payload?.id}`
              : `${eramanHost}/api/create-footer-section-icons-items-taxonomy-data-list`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
